import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	gap: var(--spacing-x-small);
	color: var(--neutrals-500);
	.motif-icon {
		--size: var(--px-18);
		color: inherit;
	}
`;
